export default "__VITE_ASSET__fwPTfUbY__"